/**
 * Tracking de la soumission du formulaire Shopify Forms de la landing B2B
 * (template page.b2b-landing).
 *
 * Le formulaire est rendu par l'app Shopify Forms dans un shadow DOM ouvert
 * (<shopify-forms-embed>). L'événement submit n'en sort pas et ne garantit pas
 * un envoi réussi, on observe donc l'étape courante du formulaire : l'app pose
 * data-current-step="success" sur #app-embed une fois la soumission acceptée.
 *
 * Côté web pixel : analytics.subscribe('LeadB2B', ...)
 * Payload : aucun (les champs sont des données personnelles).
 */
(function () {
  const EVENT_NAME = 'LeadB2B';
  const HOST_SELECTOR = 'shopify-forms-embed';
  const POLL_INTERVAL = 500;
  const POLL_TIMEOUT = 60000;

  const publish = () => {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(EVENT_NAME, {});
    }
  };

  const watch = (shadowRoot) => {
    let fired = false;
    const check = () => {
      if (fired) return;
      const root = shadowRoot.getElementById('app-embed');
      if (root && root.getAttribute('data-current-step') === 'success') {
        fired = true;
        publish();
      }
    };
    new MutationObserver(check).observe(shadowRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-current-step'],
    });
    check();
  };

  const watched = new WeakSet();
  const started = Date.now();

  const poll = () => {
    document.querySelectorAll(HOST_SELECTOR).forEach((host) => {
      if (watched.has(host) || !host.shadowRoot) return;
      watched.add(host);
      watch(host.shadowRoot);
    });
    if (Date.now() - started < POLL_TIMEOUT) window.setTimeout(poll, POLL_INTERVAL);
  };

  poll();
})();
